import { title, desc, link } from "../../content/Form"
import { disableSendButton } from "../../scripts/disableSendButton";

function Form() {
  return (
    <div
      className="container px-4 py-5 my-4 container-wide box-shadow"
      id="send_email"
    >
      <div className="row align-items-center g-lg-5 px-3">
        <div className="col-0 col-lg-1" />
        <div className="col-lg-4 col-xl-5 text-center text-lg-start">
          <h1 className="fw-bold lh-1 text-body-emphasis mb-3 quint palegreen">
            {title}
          </h1>
          <p className="col-lg-10 fs-6">{desc}</p>
          <a href="/elerhetosegek" className="icon-link palegreen mb-4">
            {link}
            <i className="bi bi-chevron-right palegreen" />
          </a>
        </div>
        <div className="col-md-10 mx-md-auto mx-0 col-lg-6 col-xl-5">
          <form
            className="p-4 p-md-5 border rounded-3 bg-body-tertiary"
            action="https://formsubmit.co/14e2aad6f47d80d03e12117733b6b28f"
            method="post"
            id="form"
            onSubmit={disableSendButton}
          >
            <input type="hidden" name="_captcha" defaultValue="false" />
            <input type="hidden" name="_replyto" defaultValue="true" />
            <input
              type="hidden"
              name="_next"
              defaultValue="https://bowenegyensuly.hu/email-kuldve.html"
            />
            <input type="hidden" name="_template" defaultValue="box" />
            <div className="form-floating mb-3">
              <input
                className="form-control"
                type="text"
                id="name"
                name="name"
                placeholder="Add meg a neved"
                required=""
              />
              <label htmlFor="name">Név</label>
            </div>
            <div className="form-floating mb-3">
              <input
                className="form-control"
                type="email"
                id="email"
                name="email"
                placeholder="valaki@valami.hu"
                required=""
              />
              <label htmlFor="email">E-mail cím</label>
            </div>
            <div className="form-floating mb-3">
              <input
                className="form-control"
                type="text"
                id="subject"
                name="_subject"
                placeholder="Tárgy"
                required=""
              />
              <label htmlFor="subject">Tárgy</label>
            </div>
            <div className="form-floating mb-3">
              <textarea
                className="form-control"
                id="message"
                name="message"
                rows={4}
                style={{ height: "100%" }}
                placeholder="Üzenet"
                required=""
                defaultValue={""}
              />
              <label htmlFor="body">Üzenet</label>
            </div>
            <button
              className="w-100 btn btn-primary quint"
              type="submit"
              id="button"
            >
              <span
                className="spinner-border spinner-border-sm"
                aria-hidden="true"
                id="spinner"
                hidden
              />
              Küldés
            </button>
          </form>
        </div>
        <div className="col-0 col-lg-1" />
      </div>
    </div>
  );
}

export default Form;
